import React from 'react';

interface Props {
  count: number;
}

export const Notification: React.FC<Props> = ({ count }) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span className="inline-flex size-[18px] items-center justify-center rounded-full bg-accent text-caption-10 font-semibold text-foreground contrast:text-accent-foreground">
      {count}
    </span>
  );
};
